
import * as bitcoin from 'bitcoinjs-lib'

//import TransportWebHID from "@ledgerhq/hw-transport-webhid";

import { AppClient, DefaultWalletPolicy, WalletPolicy, PsbtV2 } from 'ledger-bitcoin';

import Btc from "@ledgerhq/hw-app-btc";

import {splitTransaction, serializeTransactionOutputs} from './lib'

//import { listen } from "@ledgerhq/logs";

const MAINNET = {
    /**
     * The message prefix used for signing Bitcoin messages.
     */
    messagePrefix: '\x18Bitcoin Signed Message:\n',
    /**
     * The Bech32 prefix used for Bitcoin addresses.
     */
    bech32: 'bc',
    /**
     * The BIP32 key prefixes for Bitcoin.
     */
    bip32: {
      /**
       * The public key prefix for BIP32 extended public keys.
       */
      public: 0x0488b21e,
      /**
       * The private key prefix for BIP32 extended private keys.
       */
      private: 0x0488ade4,
    },
    /**
     * The prefix for Bitcoin public key hashes.
     */
    pubKeyHash: 0x00,
    /**
     * The prefix for Bitcoin script hashes.
     */
    scriptHash: 0x05,
    /**
     * The prefix for Bitcoin Wallet Import Format (WIF) private keys.
     */
    wif: 0x80,
}

const TESTNET = {
    messagePrefix: '\x18Bitcoin Signed Message:\n',
    bech32: 'tb',
    bip32: {
      public: 0x043587cf,
      private: 0x04358394,
    },
    pubKeyHash: 0x6f,
    scriptHash: 0xc4,
    wif: 0xef,
}

class HWI {
    /**
     * HWI is a class useful to instantiate the HWI client.
     * The client is able to open/close a transport connection to a Ledger hardware device.
     */
    constructor(TransportWebHID) {
        this.testnet = false
        this.debugger = false
        this.appversion = 0
        
        this.b64 = ""
        this.hex = ""

        this.psbt = {}
        this.psbtLedger = {}
        
        this.TransportWebHID = TransportWebHID
        this.transport = TransportWebHID
        this.isOpen = false
        this.appBtc = null
        this.appBtcNew = null
        
        this.policy = ""
        this.descriptorTemplate = "wsh(andor(multi(2,@0/**,@1/**,@2/**),multi(3,@3/**,@4/**,@5/**,@6/**,@7/**,@8/**),and_v(v:multi(2,@9/**,@10/**,@11/**),older(184))))"

        this.wallet = {
            address: "",
            policyHmac: "",
            walletPolicy: {}
        }
    }

    /**
     * Function used to create an empty PSBT object with bitcoin-lib
     */
    createPsbt(type="", network="") {
        //p2wsh
        //this.psbt = bitcoin.payments.p2wsh({})
        //p2ms
        //const p2ms = bitcoin.payments.p2ms({ pubkeys: publicKeys, network: NETWORK, m: 1 });
        //p2sh
        //const p2shP2ms = bitcoin.payments.p2sh({ redeem: p2ms, network: NETWORK });

        //psbt
        //this.psbt = new bitcoin.Psbt({ network: NETWORK });

        switch(type) {
            case "p2sh":
                this.psbt = new bitcoin.Psbt()
                return
            case "p2wsh":
                this.psbt = new bitcoin.Psbt()
                return
            default:
                this.psbt = new bitcoin.Psbt()
        }
        console.log(this.psbt)
    }

    /**
     * Function used to import a PSBT from a base64 string
     */
    importFromB64(data) {
        this.b64 = data
        const hex = base64ToHex(data)
        this.hex = hex
        this.decode()
    }

    /**
     * Function used to import a PSBT from a raw hex string
     */
    importFromHex(data) {
        this.psbt = bitcoin.Psbt.fromHex(data,this.testnet?TESTNET:MAINNET)
    }

    /**
     * Function used to decode a PSBT from raw hex after base64toHex conversion
     */
    decode() {
        this.psbt = bitcoin.Psbt.fromHex(this.hex,this.testnet?TESTNET:MAINNET)
    }

    /**
     * Function used to extract useful informations from a PSBT
     */
    getPsbtInfo() {
        const txInfo = {}
        /**
         * this.psbt.txOutputs[i].address !
         * this.psbt.txOutputs[i].value !
         * this.psbt.data.inputs[i].bip32Derivation.[j].masterFingerprint
         * this.psbt.data.inputs[i].bip32Derivation.[j].pubkey
         * this.psbt.data.inputs[i].bip32Derivation.[j].path
         * this.psbt.data.inputs[i].partialSig[i].pubkey
         * this.psbt.data.inputs[i].partialSig[i].signature
         */
        try {
            txInfo.to = this.psbt.txOutputs?.length > 0  && this.psbt.txOutputs.map(item=>{return {address:item.address,value:item.value}}) //[...this.psbt.txOutputs.map(item=>{return item.address})]
            txInfo.bip32 = []
            this.psbt.data.inputs?.length > 0 && this.psbt.data.inputs.map(item=>{
                item.bip32Derivation?.length > 0 && item.bip32Derivation.map(el=>{
                    txInfo.bip32.push({
                        fgpr: Buffer.from(el.masterFingerprint).toString('hex'),
                        pubkey: Buffer.from(el.pubkey).toString('hex'),
                        path: el.path
                    })
                })
            })
            txInfo.signatures = []
            this.psbt.data.inputs?.length > 0 && this.psbt.data.inputs.map(item=>{
                item.partialSig?.length > 0 && item.partialSig.map(el=>{
                    txInfo.signatures.push({
                        pubkey: Buffer.from(el.pubkey).toString('hex'),
                        signature: Buffer.from(el.signature).toString('hex')
                    })
                })
            })
        } catch (error) {
            console.log("[PSBT-ERROR]: unable to get info", error) 
        }
        
        return txInfo
    }

    /**
     * Function used to open a transport client to Ledger device
     */
    async getClient() {
        this.transport = await this.TransportWebHID.create();
        this.appBtc = new AppClient(this.transport);
        const transport = this.transport
        this.appBtcNew = new Btc({ transport, currency: "bitcoin" });
        this.isOpen = true
        this.appversion = await this.appBtc.getAppAndVersion()
        console.log("[APP version]: ", this.appversion)
    }

    async isBrowserSupported() {
        return await this.TransportWebHID.isSupported()
    }

    /**
     * Function used to close a transport client Ledger device
     */
    async closeClient() {
        await this.transport.close()
        this.isOpen = false
        console.log("Ledger transport closed...")
    }

    /**
     * Function used to decode a transaction with Ledger
     */
    decodeTX(tx,segwit=true,additionals=["bech32"]) {
        
        //this.psbtLedger = this.appBtcNew.splitTransaction(tx,segwit,false,additionals) //
        this.psbtLedger = splitTransaction(tx,segwit,false,additionals)
        //this.psbtLedger = this.appBtcNew.splitTransaction(tx,segwit,null,[])
        //console.log("splitted transaction:", this.psbtLedger)
        
        //const serOut = this.appBtcNew.serializeTransactionOutputs(this.psbtLedger).toString('hex')
        const serOut = serializeTransactionOutputs(this.psbtLedger).toString('hex')        
        //console.log("outputScriptHex: ", serOut)

        //const trustedInput = segwit? null : await this.appBtcNew.getTrustedInput(index,this.psbtLedger,["bech32"])
        //console.log("[TrustedInput]: ", trustedInput)

        //const trustedInput143 = segwit? await this.appBtcNew.getTrustedInputBIP143(index,this.psbtLedger,["bech32"]):null
        //console.log("[TrustedInputBIP143]: ", trustedInput143)

        //return {tx:this.psbtLedger,outputScript:serOut,trustedInput:segwit ? trustedInput143 : trustedInput}
        return {tx:this.psbtLedger,outputScript:serOut}
    }

    async getTrustedInputs(index,segwit,additionals=[]) {
        const trustedInput = segwit? null : await this.appBtcNew.getTrustedInput(index,this.psbtLedger,additionals)
        console.log("[TrustedInput]: ", trustedInput)

        const trustedInput143 = segwit? await this.appBtcNew.getTrustedInputBIP143(index,this.psbtLedger,additionals):null
        console.log("[TrustedInputBIP143]: ", trustedInput143)

        return {trustedInput:segwit ? trustedInput143 : trustedInput}
    }

    /**
     * Function used to get the fingerprint of the connected Ledger
     */
    async getFingerprint() {
        const fgpr = await this.appBtc.getMasterFingerprint();
        return fgpr
    }

    /**
     * Function used to get the uncompressed public key from connected Ledger
     */
    async getPub(path="m/44'/0'/0'/0/0") {
        let format
        switch(path.slice(2,4)) {
            case "44":
                format = "legacy"
                break
            case "49":
                format = "p2sh"
                break
            case "84":
                format = "bech32"
                break
            case "86":
                format = "bech32m"
                break
            default:
                format = "bech32"
        }
        //console.log("[POLICY type]",path.slice(2,4),format)
        const pub = await this.appBtcNew.getWalletPublicKey(path,{verify:false, format}) // TODO: fix format
        //console.log("[PUBext]: ", pub.publicKey.length , pub.publicKey)
        /*
        .then(o => {
            const buf = Buffer.from(o.publicKey,'hex').slice(1)

            //const final = buf.length === 64 ? Buffer.concat([0x02,buf.slice(0,32)]).toString('hex') : Buffer.concat([0x03,buf.slice(0,32)]).toString('hex')

            console.log("[PUB]: ", buf.length , o.publicKey)

            return o.publicKey
        })
        */
        return pub.publicKey
    }

    /**
     * Function used to get the extend public key from connected Ledger
     */
    async getXpub(path="m/44'/0'/0'/0/0") {
        const xpub = await this.appBtc.getExtendedPubkey(path, false)
        return xpub
    }

    /**
     * Function used to get the corresponding derivation path address
     */
    async getAddress(path="m/44'/0'/0'/0/0",format="bech32") {
        //console.log("getting address..")
        //console.log(this.appversion.name,this.appversion.version,parseFloat(this.appversion.version))
        if (parseFloat(this.appversion.version) < 2.1) {
            return (await this.appBtcNew.getWalletPublicKey(path,{format})).bitcoinAddress // TODO: path.slice(2,4) === "44" || "49" || "84" || "86"
        }
        
        const fpr = await this.getFingerprint()

        const decodedPath = path.split("/")

        let purpose = "" //decodedPath[0]
        let coinType = decodedPath[2] //path.slice(6,8)
        let account = decodedPath[3] //path.slice(9,11)
        let change = decodedPath[4] //path.slice(12,13)
        let index = decodedPath[5] //path.slice(14,15)
        
        //const accountPubkey = await this.getXpub(path.slice(0, path.length - 4)) // TODO:
        const accountPubkey = await this.getXpub(`${decodedPath[0]}/${decodedPath[1]}/${coinType}/${account}`)

        const formats = {
            pkh : "44'",
            sh : "49'",
            wpkh : "84'",
            tr : "86'",
        }        

        console.log(`[DECODED PATH]: ${coinType} | ${account} | ${change} | ${index}`)
        let addressType = ""

        Object.keys(formats).map(item=>{
            if (formats[item] === decodedPath[1]) {
                addressType = item
                purpose = formats[item]
                //return item
            }
        })
        
        const accountPolicy = new DefaultWalletPolicy(
            decodedPath[1] === "49'" ? `sh(wpkh(@0/**))` : `${addressType}(@0/**)`, // TODO: p2sh -> sh(wpkh(@0/**)) 
            `[${fpr}/${purpose}/${coinType}/${account}]${accountPubkey}`
        );
        console.log(fpr,accountPubkey,accountPolicy)
        
        const bitcoinAddress = await this.appBtc.getWalletAddress(
            accountPolicy,
            null,
            parseInt(change)||0, //change
            parseInt(index)||0, //address index
            false // show address on the wallet's screen
        )
        
        console.log("[Address]:",bitcoinAddress)
        return bitcoinAddress
    }

    /**
     * Function used to register a Wallet Policy with the Ledger
     */
    async registerWallet(name="WALLET", keychains) {

        const app = new AppClient(this.transport);
        //listen(log => console.log(log))

        /*
        const formats = {
            pkh : "44'",
            sh : "49'",
            wpkh : "84'",
            tr : "86'",
        }

        //const paths = path.split("|")
        //const decodedPath = path.split("/")
        //console.log("[PATHS] ", paths)

        let purpose = ""
        let coinType = decodedPath[2] //path.slice(6,8)
        let account = decodedPath[3] //path.slice(9,11)
        let change = decodedPath[4] //path.slice(12,13)
        let index = decodedPath[5] //path.slice(14,15)
        console.log(`[DECODED PATH]: ${coinType} | ${account} | ${change} | ${index}`)
        let addressType = ""

        Object.keys(formats).map((item,i)=>{
            if (formats[item] === decodedPath[1]) {
                addressType = item
                purpose = formats[item]
            }
        })
        
        //const fpr = await app.getMasterFingerprint(); // this.getFingerprint()
        //const ourPubkey = await app.getExtendedPubkey(path); // TODO : ?

        //const ourKeyInfo = `[${fpr}/${purpose}/${coinType}/${account}]${ourPubkey}`;
        //console.log("My Ledger XPubKey:", ourKeyInfo) // TODO: ??
        */

        const walletPolicy = new WalletPolicy(
            name,
            this.descriptorTemplate,        
            //this.getKeys(path)
            this.fetchXpubs(keychains) //this.getKeys(paths,keychains) // TODO: fix!!!
        )

        //console.log("Wallet Policy:",  walletPolicy)

        const [policyId, policyHmac] = await app.registerWallet(walletPolicy);
        
        //console.log(`[Policy ID]: ${policyId.toString("hex")} | [Policy HMAC]: ${policyHmac.toString("hex")}`);

        //console.assert(policyId.compare(walletPolicy.getId()) == 0)

        //const walletAddress = await app.getWalletAddress(walletPolicy, policyHmac, parseInt(change)||0, parseInt(index)||0, true);
        //console.log(`Multisig wallet address: ${walletAddress}`);
        
        this.wallet.policyHmac = policyHmac
        this.wallet.walletPolicy = walletPolicy

        return this.wallet
    }

    async getPolicyAddress(path, policy) {

        const app = new AppClient(this.transport);
        //listen(log => console.log(log))
        /*
        const formats = {
            pkh : "44'",
            sh : "49'",
            wpkh : "84'",
            tr : "86'",
        }
        */

        //const paths = path.split("|")
        const decodedPath = path.split("/")
        //console.log("[PATHS] ", paths)

        //let purpose = ""
        //let coinType = decodedPath[2] //path.slice(6,8)
        //let account = decodedPath[3] //path.slice(9,11)
        let change = decodedPath[4] //path.slice(12,13)
        let index = decodedPath[5] //path.slice(14,15)
        //console.log(`[DECODED PATH]: ${coinType} | ${account} | ${change} | ${index}`)
        /*
        let addressType = ""

        Object.keys(formats).map((item,i)=>{
            if (formats[item] === decodedPath[1]) {
                addressType = item
                purpose = formats[item]
            }
        })

        //const fpr = await app.getMasterFingerprint(); // this.getFingerprint()
        //const ourPubkey = await app.getExtendedPubkey(path); // TODO : ?

        //const ourKeyInfo = `[${fpr}/${purpose}/${coinType}/${account}]${ourPubkey}`;
        //console.log("My Ledger XPubKey:", ourKeyInfo) // TODO: ??
        
       
        const multisigPolicy = new WalletPolicy(
            name,
            this.descriptorTemplate,        
            //this.getKeys(path)
            this.fetchXpubs(keychains) //this.getKeys(paths,keychains) // TODO: fix!!!
        )

        console.log("Wallet Policy:",  multisigPolicy)

        const [policyId, policyHmac] = await app.registerWallet(multisigPolicy);
        
        console.log(`[Policy ID]: ${policyId.toString("hex")} | [Policy HMAC]: ${policyHmac.toString("hex")}`);

        //console.assert(policyId.compare(multisigPolicy.getId()) == 0)
        */

        const walletAddress = await app.getWalletAddress(policy.walletPolicy, policy.policyHmac, parseInt(change)||0, parseInt(index)||0, true);
        console.log(`wallet address: ${walletAddress}`);

        this.wallet.address = walletAddress

        return walletAddress
    }

    async registerWalletPath(path, name="RMS WALLET", keychains) {

        const app = new AppClient(this.transport);
        //listen(log => console.log(log))

        const formats = {
            pkh : "44'",
            sh : "49'",
            wpkh : "84'",
            tr : "86'",
        }

        const paths = path.split("|")
        const decodedPath = path.split("/")
        //console.log("[PATHS] ", paths)

        let purpose = ""
        let coinType = decodedPath[2] //path.slice(6,8)
        let account = decodedPath[3] //path.slice(9,11)
        let change = decodedPath[4] //path.slice(12,13)
        let index = decodedPath[5] //path.slice(14,15)
        //console.log(`[DECODED PATH]: ${coinType} | ${account} | ${change} | ${index}`)
        let addressType = ""

        Object.keys(formats).map((item,i)=>{
            if (formats[item] === decodedPath[1]) {
                addressType = item
                purpose = formats[item]
            }
        })

        //const fpr = await app.getMasterFingerprint(); // this.getFingerprint()
        //const ourPubkey = await app.getExtendedPubkey(path); // TODO : ?

        //const ourKeyInfo = `[${fpr}/${purpose}/${coinType}/${account}]${ourPubkey}`;
        //console.log("My Ledger XPubKey:", ourKeyInfo) // TODO: ??
       
        const walletPolicy = new WalletPolicy(
            name,
            this.descriptorTemplate,        
            //this.getKeys(path)
            this.fetchXpubs(keychains) //this.getKeys(paths,keychains) // TODO: fix!!!
        )

        //console.log("Wallet Policy:",  walletPolicy)

        const [policyId, policyHmac] = await app.registerWallet(walletPolicy);
        
        //console.log(`[Policy ID]: ${policyId.toString("hex")} | [Policy HMAC]: ${policyHmac.toString("hex")}`);

        //console.assert(policyId.compare(walletPolicy.getId()) == 0)

        const walletAddress = await app.getWalletAddress(walletPolicy, policyHmac, parseInt(change)||0, parseInt(index)||0, true);
        //console.log(`Multisig wallet address: ${walletAddress}`);

        this.wallet.policyHmac = policyHmac
        this.wallet.walletPolicy = walletPolicy
        this.wallet.address = walletAddress

        return this.wallet
    }

    async signMessage(path,message, RandS = false) {
        const sig = await this.appBtcNew.signMessage(path,Buffer.from(message,'hex'))
        //console.log("[SIG]: ", sig)
        if (RandS) {
            this.debugger && console.log(sig)
            return Buffer.concat([Buffer.from(sig.r, 'hex'), Buffer.from(sig.s, 'hex')])
        } else {
            return sig
        }    
    }

    /**
     * Function used to partially sign a PSBT
     */
    async signPsbt() {
        //path="m/44'/1'/0'"
        const app = new AppClient(this.transport);
        //listen(log => console.log(log))
        //const fpr = await this.getFingerprint()
        
        // ==> Register a multisig wallet named "FRZN Wallet"
        //const ourPubkey = await this.getXpub(path)
        //const ourKeyInfo = `[${fpr}${path.slice(1)}]${ourPubkey}`;
        //console.log("My Ledger XPubKey:",ourKeyInfo) // TODO: ??

        // ==> Sign a psbt
        const rawPsbtBase64 = this.b64; // a base64-encoded psbt file to sign
        const signingPolicy = this.wallet.walletPolicy //multisigPolicy; // an instance of WalletPolicy
        const signingPolicyHmac = this.wallet.policyHmac //policyHmac; // if not a default wallet policy, this must also be set
        if (!rawPsbtBase64 || !signingPolicy) {
            console.log("Nothing to sign");
            await transport.close();
            return;
        }

        const psbtBufToSign = Buffer.from(this.b64, "base64");

        const psbtToSign = new PsbtV2();
        psbtToSign.deserialize(psbtBufToSign);

        const signatures = await app.signPsbt(psbtToSign, signingPolicy, signingPolicyHmac);
        //const result = await app.signPsbt(this.b64, signingPolicy, signingPolicyHmac);
        
        //console.log("Returned signatures:");
        //console.log(`${result[0][0]} : ${result[0][1].pubkey.toString("hex")} : ${result[0][1].signature.toString("hex")}`);
        
        //console.log("[SIGN RES]: ", signatures)
        this.addSignatures(signatures)

        // result.map((input,i)=>{
        //     //this.addSignature(result[i][1].pubkey,result[i][1].signature,result[i])
        //     console.log("[???]: ",input[0],input[1].pubkey,input[1].signature)
        //     this.addSignature(input[1].pubkey,input[1].signature,input[0])
        // })

        const psbt = new PsbtV2()
        const psbtBuf = Buffer.from(this.b64,"base64");
        psbt.deserialize(psbtBuf);

        const serialized = psbt.serialize()
        
        //console.log("PSBT",this.psbt)
        //console.log("PSBTV2",psbt)
        //console.log("serialized",serialized.toString("hex"))
        
        return signatures
    }

    /**
     * Function used to create a transaction with App Bitcoin < 2.1.0 P2PKH
     */
    async createPaymentTX(ins=[],keyChain,outScript="",segwit=true,additionals=["bech32"]) {
        const res = await this.appBtcNew.createPaymentTransaction({
            inputs: [
                ...ins
            ],            
            associatedKeysets: [...keyChain],
            //changePath: [],
            outputScriptHex: outScript,
            //lockTime: 0,
            //sigHashType: 1,
            segwit: segwit,
            additionals: additionals,
            //transactionVersion: 2
            //useTrustedInputForSegwit: true
        })
        return res
    }

    /**
     * Function used to sign a transaction with App Bitcoin < 2.1.0 P2SH
     */
    async signP2SHTX(ins=[],keyChain,outScript="",segwit=true,additionals=["bech32"]) {
        const res = await this.appBtcNew.signP2SHTransaction({
            inputs: [
                ...ins
            ],
            associatedKeysets: [...keyChain],
            changePath: [...keyChain],
            outputScriptHex: outScript,
            segwit: segwit,
            //transactionVersion: 2,
            //lockTime: 0,
            //sigHashType: 1,
            additionals: additionals
        })
        return res
    }

    /**
     * Function used to add a signature to the PSBT
     */
    async addSignatureToInput(pubkey,signature,index) {
        this.psbt.data.inputs.length > 0 && 
        this.psbt.data.inputs.map((input,i)=>{
            console.log("INPUT",i,index)
            //console.log("!!!", input)
            if (input.partialSig?.length > 0) {
                console.log("adding a new signature",i)
                //input.partialSig.push({pubkey:pubkey,signature:signature})
                this.psbt.data.inputs[index].partialSig.push({pubkey:pubkey,signature:signature})
            } else {
                console.log("update a new signature",i)
                this.psbt.updateInput(index,{partialSig:[{pubkey:pubkey,signature:signature}]})
            }
        })
    }

    async addSignatures(signatures) {
        //console.log(this.psbt.data.inputs)
        //console.log(signatures)
        
        signatures.map((el, i) => {
            const index = el[0]
            const { pubkey, signature } = el[1];
            if (this.psbt.data.inputs[index]?.partialSig) {
                this.psbt.data.inputs[index].partialSig.push({ pubkey: pubkey, signature: signature });
            } else {
                this.psbt.updateInput(index, { partialSig: [{ pubkey: pubkey, signature: signature }] }); //TODO: input index
            }
            //console.log('RESULT[i]', el, i, index);
        });
    }

    /**
     * Function used to validate PSBT's signatures
     */
    async validateSignatures(callback) {
        //this.decode()
        //console.log(this.psbt)
        const validator = ""
        
        //const validate = await this.psbt.validateSignaturesOfAllInputs()
        //console.log("[VALIDATE]: ", validate)
        this.psbt.finalizeAllInputs()
        return this.psbt.extractTransaction(true) //.toHex()

        //console.log("Finalized",)
        //console.log("Extract Transaction",)
    }

    /**
     * Function used to edit PSBT data fields
     */
    editPsbt(to="",amount) {
        this.psbt.addInput({
            hash: Buffer.from("0000000000000000000000000000000000000000000000000000000000000000",'hex'), //utxo.getId(),
            index: 0, //txIndex,
            //nonWitnessUtxo: Buffer.from(""), //utxo.toBuffer(),
            redeemScript: Buffer.from(""),
          });
        this.psbt.addOutput({
            address: to,
            value: amount
        });
        //this.psbt.setVersion(version);
    }

    /**
     * Function used to retrieve the corresponding Keychains involved in a PSBT
     */
    /*
    getKeys(path="m/44'/0'/0'/0/0",keychains) {
        const xpubs = this.fetchXpubs(keychains)

        //const keyChains = this.psbt.data.inputs[0].bip32Derivation
        
        const keys = []

        xpubs.map((key,i)=>{
            keys.push(`[${key.fgpr}${path.slice(1)}]${key.xpub}`) //v2.1.3
        })
        
        return keys
    }
    */

    /**
     * Function used to fetch the Extended pubkeys involved in a Keychains from an ENV file/Server
     */
    /*
    fetchXpubs(keychains) {
        const xpubsList = keychains;
        const xpubs = xpubsList.split(",").map(key=>{
            const xpubsMap = key.split("|")
            return {fgpr: xpubsMap[0], xpub: xpubsMap[1]}
        })
        return xpubs
    }
    */

    fetchXpubs(keychains) {
        const xpubs = keychains.split(",").map(key=>{
            const derivation = key.split(":")
            const xpub = derivation[1].split("|")
            //console.log("???: ", derivation,xpub)
            return {fgpr: derivation[0], path: xpub[0], xpub: xpub[1]}
        })
        const keys = []

        xpubs.map((key,i)=>{
            keys.push(`[${key.fgpr}${key.path.slice(1)}]${key.xpub}`) //v2.1.3
        })
        //console.log(keys)
        return keys
    }

    /**
     * Set the Descriptor Template
     */
    setDescriptorTemplate(descriptor) {
        this.descriptorTemplate = descriptor
    }

    /**
     * Function used to export a PSBT object to base64
     */
    toBase64() {
        return this.psbt.toBase64()
    }

    compressPublicKey(pk) {
        const sliced = Buffer.from(pk,'hex').slice(1)
        const len = sliced.length
        const x = sliced.slice(0,32)
        const y = sliced.slice(32,sliced.length)
      
        const prefix = BigInt(`0x${y.toString('hex')}`) % 2n === 0n ? "02" : "03"
        return (prefix + pk.slice(2,66)).toString('hex');
    }
}

function base64ToHex(str) {
    const raw = atob(str);
    let result = '';
    for (let i = 0; i < raw.length; i++) {
      const hex = raw.charCodeAt(i).toString(16);
      result += (hex.length === 2 ? hex : '0' + hex);
    }
    return result.toUpperCase();
}

//module.exports = HWI
export default HWI
